import { Route, Routes } from "react-router-dom";
import Home from "../pages/home";
import ServicePage from "../pages/products/service";
import About from "../pages/about/aboutsus";
import Contact from "../pages/contact/contact";
import Login from "../pages/login/login";
const publicRoutes = [
  {
    path: "/",
    label: "Home",
    component: <Home />,
    private: false,
  },
  {
    path: "/services/:service",
    label: "Service Page",
    component: <ServicePage />,
    private: false,
  },
  {
    path: "/About",
    label: "About",
    component: <About />,
    private: false,
  },
  {
    path: "/Contact",
    label: "Contact",
    component: <Contact />,
    private: false,
  },
  {
    path: "/Login",
    label: "Login",
    component: <Login />,
    private: false,
  },
];

const AppRouter = () => {
  const publicPageRoutes = publicRoutes.map(({ label, path, component }) => (
    <Route key={label} path={path} element={component} />
  ));

  return (
    <Routes>
      {/* Public Routes */}
      {publicPageRoutes}

      {/* Catch-All Route (Optional: Redirect to Home if route not found) */}
      <Route path="*" element={<Home />} />
    </Routes>
  );
};

export default AppRouter;
